import Meta from '../components/Meta.js';

function NoPage() {
	return (
		<>
			<Meta title='404' />
			<h1>404 Page Not Found</h1>
		</>
	);
};

export default NoPage;
